module.exports = __webpack_public_path__ + "img/save-mind.f9d74e0e.svg";